<template>
</template>
<script>
    import Shared from '../shared';
    import { mapActions } from 'vuex';
    import {                
        NAMESPACE as APP_NAMESPACE
    } from '../store/modules/app.js';

    export default {
        data() {
            return {
                shared: Shared
            }
        },
        methods: {
            ...mapActions({
                sendNotification: APP_NAMESPACE.actions.SEND_NOTIFICATION
            }),
            dispatchNotifications: function() {
                this.notifications.forEach(function(notification) {
                    if (notification.dispatched === false) {
                        this.sendNotification(notification);
                    }
                }.bind(this));                
            }
        },
        computed: {
            notifications: function() {                
                return this.shared.notifications;
            }
        },
        watch: {
            notifications: function(notification) {                
                this.dispatchNotifications();
            }
        },
        mounted() {
            this.dispatchNotifications();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/NotificationHandler.vue